/*eslint-disable*/
import React, { useEffect, useState } from 'react'

import { Link, useNavigate, useParams } from "react-router-dom";
import { MdKeyboardArrowRight } from 'react-icons/md';
import { api_url } from '../Constants/web_services';
import contactBanner from "../Assets/images/job-banner.jpg";
import { FaUserLock } from 'react-icons/fa';


const ForgotPassword = () => {
  // const { id } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isPasswordMatch, setIsPasswordMatch] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const navigate = useNavigate();
  const { code } = useParams();
  useEffect(() => {
    const urlParts = window.location.pathname.split('/');
    const code = urlParts[urlParts.length - 1];
    const userId = urlParts[urlParts.length - 2];
    if (code && userId) {
      handleChangePassword();
    }
  }, [code])



  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => password === confirmPassword;

  const passwordMatch = () => {
    if (password?.length > 0) {
      if (password === confirmPassword) {
        setIsPasswordMatch(true);
        return;
      }
      setIsPasswordMatch(false);
    }
    setIsPasswordMatch(false);
  };

  const handleChangePassword = async (e) => {
    if (e) {

      e.preventDefault();
    }

    const urlParts = window.location.pathname.split('/');
    const token = urlParts[urlParts.length - 1];
    const userId = urlParts[urlParts.length - 2];

    // Prepare the request data
    const requestData = {
      password: password,
      token: token,
      userId: userId,
    };

    // Make the API request using the Fetch API
    fetch(api_url + '/api/user-reset-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },

      mode: 'no-cors',
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        } else {
          setConfirmPassword('');
          setPassword('');
          navigate('/');

        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  };
  return (
    <div>
      {isValid && <>
        <>
          <div className="aon-page-benner-area">
            <div
              className="aon-page-banner-row"
              style={{ backgroundImage: `url(${contactBanner})` }}
            >
              <div
                className="sf-overlay-main"
                style={{ opacity: "0.8", backgroundColor: "#022279" }}
              />
              <div className="sf-banner-heading-wrap">
                <div className="sf-banner-heading-area">
                  <div className="sf-banner-heading-large">Forgot Password</div>
                  <div className="sf-banner-breadcrumbs-nav">
                    <ul className="list-inline">
                      <ul className="list-inline">
                        <Link to="/" className='text-decoration-none text-white'>Home
                          <MdKeyboardArrowRight className='mx-1' />
                        </Link>
                        <Link to="/forgotpassword" className='text-decoration-none text-white '>Forgot Password</Link>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="aon-contact-area">
            <div className="container">
              {/*Title Section Start*/}
              <div className="section-head text-center">
                <h2 className="sf-title">Forgot Password</h2>
                <p>
                  Here you can reset your password with Special code which you have
                  got in email
                </p>
              </div>
              {/*Title Section End*/}
              <div className="section-content">
                <div className="sf-contact-form-wrap">
                  {/*Contact Information*/}
                  <div className="sf-contact-form">
                    <div className="sf-con-form-title text-center">
                      <h2 className="m-b30">Contact Information</h2>
                    </div>
                    <form onSubmit={(e) => handleChangePassword(e)}>
                      <div className="row">
                        <div className="row m-1">
                          <div className="col-md-6 p-2">
                            <div className="input-group mb-3">
                              <span
                                className="input-group-text border-end-0 bg-white aon-input-icon border-dee2e6"
                                id="basic-addon1"
                                style={{ color: "#022279" }}
                              >
                                <FaUserLock />
                              </span>
                              <input
                                placeholder="New Password"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className={`form-control  box-shadow-none border-dee2e6 ${validateForm() ? "" : "border-danger"} ${confirmPassword ? "border-success" : ""}`}
                                aria-describedby="basic-addon1"
                              />
                              <span
                                className="input-group-text  bg-white aon-input-icon border-dee2e6"
                                id="basic-addon1"
                              >
                                <i
                                  onClick={toggleShowPassword}
                                  className={`${showPassword
                                    ? "fa fa-eye text-danger"
                                    : "fa fa-eye-slash text-success"
                                    }`}
                                ></i>
                              </span>
                            </div>
                          </div>

                          <div className="col-md-6 p-2">
                            <div className="input-group mb-3">
                              <span
                                className="input-group-text border-end-0 bg-white aon-input-icon  border-dee2e6 "
                                id="basic-addon1"
                                style={{ color: "#022279" }}
                              >
                                <FaUserLock />
                              </span>
                              <input
                                className={`form-control  box-shadow-none border-dee2e6 ${validateForm() ? "" : "border-danger"} ${confirmPassword ? "border-success" : ""}`}
                                name="confirmPassword"
                                type={showPassword ? "text" : "password"}
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                              />
                              <span
                                className={`input-group-text bg-white aon-input-icon  border-dee2e6 `}
                                id="basic-addon1"
                                style={{ color: "#022279" }}
                              >
                                <i
                                  onClick={toggleShowPassword}
                                  className={`${showPassword ? "fa fa-eye text-danger" : "fa fa-eye-slash text-success"}`}
                                ></i>
                              </span>
                            </div>
                          </div>

                        </div>
                        <div className="row m-1 justify-content-center">



                          <button type="submit" className="site-button">
                            Change Password
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  {/*Contact Information End*/}
                </div>
              </div>
            </div>
          </div>
        </>

      </>}
    </div>
  )
}

export default ForgotPassword
